export default {
  apiKey: "AIzaSyBPPkaNw6VfjM1YMHKH4AzpAikBajXKod4",
  authDomain: "ajproducciones-83670.firebaseapp.com",
  databaseURL: "https://ajproducciones-83670.firebaseio.com",
  projectId: "ajproducciones-83670",
  storageBucket: "ajproducciones-83670.appspot.com",
  messagingSenderId: "699891232523",
  appId: "1:699891232523:web:e3feda7b3179d10005fc0e",
  measurementId: "G-WCMC6HXQZC"
};